import React, { useEffect } from "react";
import { GridLoader } from "../../../../rcsgrid/createGridTools";
import { clsBookGrid } from "../../../../rcsgrid/GridFunctions/clsbookGrid";
import { getTableLayout } from "../../../../Tools/Requests";
import { Prefixes } from "../../../../Tools/ProjectX";

export default function ClsBookTableForTabs({ props }) {
  const [mainGrid, setMainGrid] = React.useState();
  const gridPanel = React.useRef();
  const clsBookBox = React.useRef();

  React.useEffect(() => {
    getTableLayout({ module: Prefixes.clsBook, objType: props.DocCfgID, sectionId: props.SectionID })
      .then((res) => {
        return GridLoader(
          gridPanel.current,
          { ...props, ObjType: props.DocCfgID },
          {
            json: res,
            GroupID: props.selectedRecordID,
            ObjType: props.DocCfgID,
          },
        );
      })
      .then((res) => {
        setMainGrid(res);
      });
  }, []);

  React.useEffect(() => {
    if (mainGrid) {
      clsBookBox.current.refreshMainGrid = refreshMainGrid;
    }
  }, [mainGrid]);

  useEffect(() => {
    if (mainGrid) {
      refreshMainGrid();
    }
  }, [props]);

  async function refreshMainGrid() {
    const json = await getTableLayout({
      module: Prefixes.clsBook,
      objType: props.DocCfgID,
      sectionId: props.SectionID,
    });
    clsBookGrid(
      mainGrid.grid,
      mainGrid.source,
      { ...props, ObjType: props.DocCfgID },
      {
        json: json,
        GroupID: props.selectedRecordID,
        ObjType: props.DocCfgID,
      },
    );
  }

  return (
    <div ref={clsBookBox} id="clsBookBox" style={{ height: "100%" }}>
      <div
        id={`rcgrid_panel`}
        ref={gridPanel}
        style={{
          height: "100%",
          width: "100%",
          position: "relative",
        }}
      ></div>
    </div>
  );
}
